import { connect } from 'react-redux';
import Topbar from './Topbar';
import './Topbar.css';
import {
  getMyAccountRequest,
} from '../../redux/actions/account';
import { logout } from '../../redux/actions/login';

const mapStateToProps = state => ({
  authenticated: state.login.authenticated,
  isContributor: state.account.myAccount.info.isContributor,
  isAdmin: state.account.myAccount.info.isAdmin,
  account: state.account.myAccount.info,
  accountData: state.login.accountData,
});

const mapDispatchToProps = {
  logout,
  getMyAccountRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Topbar);
